/**
 * @generated SignedSource<<c491466825bb45690a676a8105ee9fc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SyncPageSetupMutationInput = {
  acceptedTermsOfService?: boolean | null;
  businessUse?: boolean | null;
  clientMutationId?: string | null;
  emailOptin: boolean;
  isManager?: boolean | null;
  numReports?: number | null;
  otherOrigin?: string | null;
  userOrigin?: string | null;
};
export type SyncPageMutation$variables = {
  input: SyncPageSetupMutationInput;
};
export type SyncPageMutation$data = {
  readonly syncPageSetup: {
    readonly user: {
      readonly id: string;
    };
  };
};
export type SyncPageMutation = {
  response: SyncPageMutation$data;
  variables: SyncPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SyncPageSetupMutationPayload",
    "kind": "LinkedField",
    "name": "syncPageSetup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SyncPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SyncPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8d11812f2d395c1fbbdb66aa2e386b9",
    "id": null,
    "metadata": {},
    "name": "SyncPageMutation",
    "operationKind": "mutation",
    "text": "mutation SyncPageMutation(\n  $input: SyncPageSetupMutationInput!\n) {\n  syncPageSetup(input: $input) {\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0499f6d8329fde6e6ed620ef0f0c2439";

export default node;
